module.exports = __webpack_public_path__ + "img/image5.136076e4.png";